import React from 'react';
import cn from 'classnames';
import LogoFirst from '../../assets/RandomCat1.png';
import LogoSecond from '../../assets/RandomCat2.png';

import Icon from 'Components/Icon/Icon';
import Input from 'Components/Input/Input';

import { Scrollbars } from 'react-custom-scrollbars';

const VacationCalendarEmployeeList = (props) => {
  const {
    employees,
    className,
    onPinnedEmployeesChange,
    onCalendarScroll,
    eventsListRef,
    onEmployeesSearchInputChange,
    searchInputValue,
    onListClick,
    isListToggled,
  } = props;
  return (
    <div className={cn('employees-list-container', className)}>
      <div className="employees-search">
        <span className="search__title">COLLEAGUE</span>
        <Input
          icon={<Icon name="icon-search" />}
          className="search__input"
          initialFocusState={window.outerWidth > 1024}
          fieldProps={{
            name: 'search',
            placeholder: 'Search ...',
            value: searchInputValue,
            onChange: (e) => onEmployeesSearchInputChange(e),
          }}
        />
        <Icon className="toggle-list-button" onClick={onListClick} name={isListToggled ? 'icon-right' : 'icon-close'} />
      </div>
      <Scrollbars ref={eventsListRef} onScroll={onCalendarScroll} style={{ height: 568 }} className="custom-scrollbars">
        <ul className={'employees-list'}>
          {employees.map((employee) => {
            return (
              <li
                key={employee.employeeId}
                className="employee-list__item"
                onClick={() => onPinnedEmployeesChange(employee.employeeId)}
              >
                <img
                  className="employee-avatar"
                  src={employee.avatar ? `${employee.avatar}` : employee.id % 2 === 0 ? LogoFirst : LogoSecond}
                  alt="emp-avatar"
                />
                <span className="employee-name" data-testid="employee-name">
                  {employee.employeeName}
                </span>
                <Icon
                  name="icon-pin"
                  className={cn('employee-pin-button', employee.isPinned && 'employee-pin-button--pinned')}
                />
              </li>
            );
          })}
        </ul>
      </Scrollbars>
    </div>
  );
};

export default VacationCalendarEmployeeList;
